import { useNavigate } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';

import arrowRightSimple from '../../../assets/icons/arrow-right-simple.svg';
import { NavItemStyle } from './nav-item-style';

export interface menuItemI {
  title: string;
  route?: string;
  onClick?: () => void;
}

interface NavItemI {
  title: string | React.JSX.Element;
  route?: string;
  classNames?: string;
  submenuItems?: menuItemI[];
  key?: string;
  onClick?: () => void;
  closeMenu: () => void;
}

const NavItem: React.FC<NavItemI> = ({ title, route, classNames, closeMenu, submenuItems = [], key }) => {
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [dropdownHeight, setDropdownHeight] = useState<number>(0);
  const navigate = useNavigate();
  const modalPositionListener = () => {
    if (dropdownRef.current && dropdownRef.current?.offsetHeight !== 0) {
      setDropdownHeight(dropdownRef.current.offsetHeight);
    }
  };

  useEffect(() => {
    if (dropdownRef.current && dropdownRef.current?.offsetHeight !== 0) {
      setDropdownHeight(dropdownRef.current.offsetHeight);
    }
    modalPositionListener();
    window?.addEventListener('resize', () => modalPositionListener());
    return window.removeEventListener('resize', () => modalPositionListener());
  }, [dropdownRef]);

  const handleClick = (route: string | null) => {
    if (submenuItems.length > 0) {
      setDropdownOpen((current) => !current);
    } else if (route !== null) {
      navigate(route);
    }
  };

  return (
    <>
      <NavItemStyle
        key={key}
        className={classnames(classNames, { 'with-children': submenuItems.length > 0 })}
        height={dropdownHeight}
      >
        <button className="nav-item" onClick={() => handleClick(route ? route : null)}>
          {typeof title === 'string' ? (
            <p className="nav-item__title">{title}</p>
          ) : (
            <div className="nav-item__title">{title}</div>
          )}
          {submenuItems.length > 0 ? (
            <div className={classnames('nav-item__arrow', { arrowActive: !!dropdownOpen })}>
              <img src={arrowRightSimple} alt="" />
            </div>
          ) : null}
        </button>

        {submenuItems.length > 0 && (
          <div className={classnames('dropdown', { dropdownOpen: !!dropdownOpen })}>
            <div className="dropdown-content" ref={dropdownRef}>
              {submenuItems.map((item, index) => {
                return (
                  <button
                    key={`${title}-${item.title}-${index}`}
                    className="nav-item"
                    onClick={() => {
                      closeMenu();
                      if (item.onClick) item.onClick();
                      if (item.route) navigate(item.route);
                    }}
                  >
                    <p className="nav-item__title--small">{item.title}</p>
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </NavItemStyle>
    </>
  );
};

export default NavItem;
